import {useCallback, useEffect, useState} from "react";
import {NodeView} from "../../../types/Node";
import {NodeWarningView} from "../../../types/NodeWarning";
import {useRestClient} from "../../../client/SpmRestClient";
import {useAlerts} from "../../../utils/UserAlerts";
import {Form, Spinner, Stack, Table} from "react-bootstrap";
import SelectNodeWarningType from "../../../components/SelectNodeWarningType";
import {LoadingButton} from "zavadil-react-common";
import NodeForm from "../nodes/form/NodeForm";
import {StringUtil} from "zavadil-ts-common";

export default function CheckPage() {
	const restClient = useRestClient();
	const userAlerts = useAlerts();
	const [running, setRunning] = useState<boolean>(false);
	const [rows, setRows] = useState<Array<NodeWarningView> | null>();
	const [typeId, setTypeId] = useState<string | null | undefined>();
	const [editNode, setEditNode] = useState<NodeView>();

	const loadWarnings = useCallback(
		() => {
			setRows(null);
			restClient.check
				.loadWarnings(typeId || undefined)
				.then(setRows)
				.catch((e) => userAlerts.err(e));
		},
		[restClient, userAlerts, typeId]
	);

	useEffect(loadWarnings, [typeId]);

	const runCheck = useCallback(
		() => {
			setRunning(true);
			restClient.check
				.run()
				.then(loadWarnings)
				.finally(() => setRunning(false))
				.catch((e) => userAlerts.err(e));
		},
		[restClient, userAlerts, loadWarnings]
	);

	return (
		<div>
			<h1>Kontrola</h1>
			<div>
				<Stack gap={2}>
					<Stack gap={2} direction="horizontal">
						<LoadingButton onClick={runCheck} disabled={running} loading={running}>Spustit kontrolu</LoadingButton>
					</Stack>
					<Stack gap={2} direction="horizontal">
						<Form.Label>Typ:</Form.Label>
						<SelectNodeWarningType
							typeId={typeId}
							onChange={setTypeId}
						/>
					</Stack>
					<div>{rows && `Nalezeno ${rows.length} problémů.`}</div>
				</Stack>
			</div>
			{
				rows ? <Table>
						<thead>
						<tr>
							<th>Uzel</th>
							<th>Typ</th>
						</tr>
						</thead>
						<tbody>
						{
							rows ? rows.map(
								(row) => <tr
									key={row.id}
									onClick={() => setEditNode(row.node)}
								>
									<td>
										[{row.node.id}] {StringUtil.ellipsis(row.node.text, 20)}
									</td>
									<td>{row.typeName}</td>
								</tr>
							) : <div>Nebyly nalezeny žádné problémy.</div>
						}
						</tbody>
					</Table>
					: <Spinner/>
			}
			{editNode && <NodeForm node={editNode} onSaved={() => setEditNode(undefined)} onClosed={() => setEditNode(undefined)}/>}
		</div>
	);
}
